import { jsx as _jsx } from "react/jsx-runtime";
// @ts-nocheck
import { Component } from "react";
export class Title extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (_jsx("div", Object.assign({ className: `formTitle d-flex ${this.props.className}` }, { children: this.props.text }), void 0));
    }
}
